const M = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUxMyAzNDIiPgo8cmVjdCBmaWxsPSIjYzYwYzMwIiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjM0MiIvPgo8cG9seWdvbiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjE5MCwwIDEzMCwwIDEzMCwxNDAgMCwxNDAgMCwyMDAgMTMwLDIwMCAxMzAsMzQyIDE5MCwzNDIgMTkwLDIwMCA1MTMsMjAwIDUxMywxNDAKCTE5MCwxNDAgIi8+Cjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=DK-bcaa8cdd.mjs.map
